import * as Yup from 'yup';

const SnippetSchema = () =>
  Yup.object().shape({
    title: Yup.string().required('You must provide a title'),
    content: Yup.string().required('You must provide text'),
  });

export default SnippetSchema;
